import React from 'react';

import { Container, Spinner, Text, SubText } from './styles';

const PageLoader: React.FC = () => {
  return (
    <Container>
      <Spinner />
      <Text>Carregando...</Text>
      <SubText>Aguarde um instante.</SubText>
    </Container>
  );
};

export default PageLoader;
